import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "createButton"]
  static values = { createUrl: String }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  debounceSubmit() {
    if (this.timeout) clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 500)
  }

  toggleCreateButton() {
    if (!this.hasCreateButtonTarget) return
    const hasText = this.inputTarget.value.trim().length > 3
    const hasAnyText = this.inputTarget.value.trim().length > 0

    if (hasText) {
      this.createButtonTarget.classList.add("visible")
      this.inputTarget.classList.add("search-has-create-btn")
    } else {
      this.createButtonTarget.classList.remove("visible")
      this.inputTarget.classList.remove("search-has-create-btn")
    }

    // Toggle search mode on page
    const page = document.querySelector('.task-library-page')
    if (page) {
      if (hasAnyText) {
        page.classList.add('searching')
      } else {
        page.classList.remove('searching')
      }
    }
  }

  createFromSearch() {
    const query = this.inputTarget.value.trim()
    if (!query) return

    if (this.hasCreateUrlValue && this.createUrlValue) {
      this.createTaskFromSearch(query)
    } else {
      const loginModal = document.querySelector('#loginModal')
      if (loginModal && typeof $ !== 'undefined') {
        $(loginModal).modal('show')
      }
    }
  }

  handleEnter(event) {
    if (event.key !== "Enter") return
    event.preventDefault()

    const query = this.inputTarget.value.trim()
    if (!query) return

    // First do the search
    this.element.requestSubmit()

    // After a short delay, check if results are empty and submit to task creator
    setTimeout(() => {
      const noResults = document.querySelector('.library-section + .text-center.py-5')
      if (noResults) {
        if (this.hasCreateUrlValue && this.createUrlValue) {
          this.createTaskFromSearch(query)
        } else {
          const loginModal = document.querySelector('#loginModal')
          if (loginModal && typeof $ !== 'undefined') {
            $(loginModal).modal('show')
          }
        }
      }
    }, 1000)
  }

  createTaskFromSearch(message) {
    // Navigate to the new AI task full page with the search query prefilled
    const url = new URL("/ai_tasks/new", window.location.origin)
    url.searchParams.set("prefill_message", message)
    window.location.href = url.toString()
  }
}
